var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  padding: 50px 0 25px;\n  border-top: 2px solid ', ';\n'], ['\n  background: ', ';\n  padding: 50px 0 25px;\n  border-top: 2px solid ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import Theme from '../../Theme';

var _Theme$colors = Theme.colors,
    white = _Theme$colors.white,
    bgGrey = _Theme$colors.bgGrey;


var Wrapper = styled.div(_templateObject, white, bgGrey);

export default Wrapper;